import { CoreFilterCommand, KnowledgeFeedFilter, KnowledgeFeedOrder, KnowledgeQuickFilterType, QuickFilterDto } from "generated/CoreApi_v1";
import LibUtils from "lib/LibUtils";
import { IAdvFilterCommand, IAdvFilterDropdown, IAdvFilterResult } from "views/general/AdvancedFilter/interfaces";
import { IFeedFilterOptions } from "views/knowledge/feed/components/FeedFilter";

export function getClearFilter(): IFeedFilterOptions {
    return {
        searchText: "",
        advFilters: [],
        ftsTitleAuthor: true,
        order: KnowledgeFeedOrder.MostRelevant
    };
}

function showQuickFilterName(quickFilterType: KnowledgeQuickFilterType) {

    switch (quickFilterType) {
        case KnowledgeQuickFilterType.CustomTopic:
        case KnowledgeQuickFilterType.CustomChannel:
        case KnowledgeQuickFilterType.CustomSticker:
            return false;
    }

    return true;
}

/// Cria um novo filtro a partir da seleção do Quickfilter
export function createEquivalentFilter(filterCommand: IAdvFilterCommand, quickFilter: QuickFilterDto): IAdvFilterResult {
    const text = showQuickFilterName(quickFilter.filterType) || filterCommand?.displayName == quickFilter.name
        ? quickFilter.name
        : `${filterCommand?.displayName.replace("...", "")}: ${quickFilter.name}`;

    return {
        command: filterCommand!.command,
        text,
        quickFilter: quickFilter,
        value: filterCommand.command == CoreFilterCommand.KnowledgeChannel
            ? quickFilter.channelId
            : filterCommand.command == CoreFilterCommand.KnowledgeTopic
                ? quickFilter.topicId
                : filterCommand.command == CoreFilterCommand.KnowledgeSticker
                    ? quickFilter.stickerId
                    : filterCommand.fixedValue,
        period: null,
        range: null,
        optionalGroup: filterCommand.optionGroup,
    };
}

/// Adicionar o filtro na lista de seleção
export function addFilter(newFilter: IAdvFilterResult, filterCommand: IAdvFilterCommand, advFilters: IAdvFilterResult[], quickFilter: QuickFilterDto, viewFilter: IFeedFilterOptions): IFeedFilterOptions {
    const existCommand = advFilters.find(x => x.command == newFilter.command && x.optionalGroup != null && newFilter.optionalGroup != null && x.optionalGroup == newFilter.optionalGroup);
    const existFilter = advFilters.find(x => x.command == newFilter.command && x.value == newFilter.value);

    // Substitui o filtro
    if (existCommand && !filterCommand.canRepeat) {
        return {
            ...viewFilter,
            advFilters: [...advFilters.filter(x => x != existCommand), newFilter],
        };
    }
    else if (existFilter) {
        return {
            ...viewFilter,
            advFilters: [...advFilters.filter(x => x != existFilter), newFilter],
        };
    }
    // Adiciona o filtro
    else if (existFilter) {
        return {
            ...viewFilter,
            advFilters: advFilters.map((item) => {
                if (item == existFilter) {
                    item.quickFilter = quickFilter;
                    return item;
                }
                return item;
            })
        };
    }
    else {
        return {
            ...viewFilter,
            advFilters: [...advFilters, newFilter],
        };
    }
}

///
export function clearAdvFilter(item: IAdvFilterResult, viewFilter: IFeedFilterOptions): IFeedFilterOptions {
    const clearFilter = viewFilter.advFilters.filter(x => !(x.command == CoreFilterCommand.KnowledgeQuickFilter && x.value == item.value));

    return {
        ...getClearFilter(),
        advFilters: clearFilter,
    };
}

///
export function equivalentFilterCommandFromQuickFilter(dropdownOptions: IAdvFilterDropdown[], quickFilterType: KnowledgeQuickFilterType): IAdvFilterCommand | undefined {
    for (var menuItem of dropdownOptions) {
        const filterCommand = menuItem.filterCommands.find(x => x.quickFilterType == quickFilterType);
        if (filterCommand) {
            return filterCommand;
        }
    }
    return undefined;
}

///
export function changeQuickFilter(selected: boolean, quickFilter: QuickFilterDto, dropdownOptions: IAdvFilterDropdown[], viewFilter: IFeedFilterOptions): IFeedFilterOptions {

    let advFilters = viewFilter.advFilters.filter(x => x.quickFilter == null);

    if (selected) {
        let filterCommand = equivalentFilterCommandFromQuickFilter(dropdownOptions, quickFilter.filterType);

        if (quickFilter.filterType == KnowledgeQuickFilterType.CustomSticker
            || quickFilter.filterType == KnowledgeQuickFilterType.Highlights
            || quickFilter.filterType == KnowledgeQuickFilterType.Urgent) {
            filterCommand = {
                command: CoreFilterCommand.KnowledgeSticker,
                displayName: quickFilter.name,
                canRepeat: true,
                group: 1,
                fixedValue: quickFilter.stickerId,
                quickFilterType: KnowledgeQuickFilterType.CustomSticker,
                canCheck: true
            };
        }

        if (filterCommand) {
            const newFilter = createEquivalentFilter(filterCommand, quickFilter);
            return addFilter(newFilter, filterCommand, advFilters, quickFilter, viewFilter);
        }
        else {
            const newFilter: IAdvFilterResult = {
                command: CoreFilterCommand.KnowledgeQuickFilter,
                text: quickFilter.name,
                quickFilter: quickFilter,
                value: null,
                period: null,
                range: null
            };

            return {
                ...viewFilter,
                advFilters: [...advFilters, newFilter]
            };
        }
    }
    else {
        return {
            ...viewFilter,
            advFilters
        };
    }
}


///
export function getClearFilterOnHideAdvFilter(viewFilter: IFeedFilterOptions): IFeedFilterOptions {
    const clearAdvFilters = viewFilter.advFilters.filter(x => x.quickFilter != null);

    return {
        ...getClearFilter(),
        advFilters: clearAdvFilters,
        ftsTitleAuthor: viewFilter.advFilters.find(p => p.command == CoreFilterCommand.KnowledgeContent) == null
    };
}

export function filterChanged(filter: IFeedFilterOptions, compare: IFeedFilterOptions) {
    return filter.searchText != compare.searchText
        || filter.order != compare.order
        || !LibUtils.compareObjects(filter.advFilters.map(x => x.command), compare.advFilters.map(x => x.command))
        || !LibUtils.compareObjects(filter.advFilters, compare.advFilters);
}

///
export function getFilter(filter: IFeedFilterOptions) {
    return filter.advFilters?.map(x => {
        return {
            command: x.command,
            value: x.value,
            period: x.period,
            quickFilter: x.quickFilter == null ? null : {
                filterType: x.quickFilter.filterType,
                topicId: x.quickFilter.topicId,
                channelId: x.quickFilter.channelId,
                stickerId: x.quickFilter.stickerId
            }
        } as KnowledgeFeedFilter;
    });
}
